import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import Lottie from "lottie-react";
import { SIGNUP_COLORS, SIGNUP_LAYOUT } from "../../../pages/public/SignUp/tokens";

import suitcaseAnimation from "../../../assets/img/animations/suitcase.json";
import membersAnimation from "../../../assets/img/animations/members.json";
import folderAnimation from "../../../assets/img/animations/folder.json";

type IntroCardProps = {
  title: string;
  description: string;
  animationData: object;
};

const IntroCard: React.FC<IntroCardProps> = ({ title, description, animationData }) => {
  return (
    <Box
      sx={{
        maxWidth: 532,
        minHeight: 160,
        borderRadius: SIGNUP_LAYOUT.borderRadius,
        border: `1px solid ${SIGNUP_COLORS.gray200}`,
        boxShadow: "0px 4px 24px rgba(71, 84, 103, 0.2)",
        bgcolor: SIGNUP_COLORS.white,
        display: "grid",
        gridTemplateColumns: "1fr 110px",
        columnGap: "20px",
        p: "24px",
      }}
    >
      <Box>
        <Typography
          sx={{
            fontFamily: "Manrope",
            fontWeight: 700,
            fontSize: "20px",
            lineHeight: "26px",
            color: SIGNUP_COLORS.primary,
            mb: "8px",
          }}
        >
          {title}
        </Typography>

        <Typography
          sx={{
            fontFamily: "Manrope",
            fontSize: "15px",
            lineHeight: "22px",
            color: SIGNUP_COLORS.textSecondary,
          }}
        >
          {description}
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}
      >
        <Lottie
          animationData={animationData}
          loop
          autoplay
          style={{ width: 80, height: 80 }}
        />
      </Box>
    </Box>
  );
};

export const Introduction: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Stack spacing={2} sx={{ px: "24px", py: "24px" }}>
      <IntroCard
        title={t("onboarding.steps.companyDetails")}
        description={t("onboarding.introduction.companyDetails")}
        animationData={suitcaseAnimation}
      />

      <IntroCard
        title={t("onboarding.steps.members")}
        description={t("onboarding.introduction.members")}
        animationData={membersAnimation}
      />

      <IntroCard
        title={t("onboarding.steps.uploadCentre")}
        description={t("onboarding.introduction.uploadCentre")}
        animationData={folderAnimation}
      />
    </Stack>
  );
};

export default Introduction;
